<app-lfsa-card [innTemplate]="enviarTemplate" 
  [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="true">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-9">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize] = "modulo.agGrid.paginacion"  [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>

  <div [formGroup]="formulario" novalidate class="form-group">
    <!-- codigoUsuario
codigoDireccion -->
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <!-- (keydown)="clearField()" -->
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Usuario'" [label]="'Usuario*'"
        (keyup)="getUsuarios()"
          [id]="'usuario'" formControlName="usuario" [control]="formulario.get('usuario')">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Cédula'" [label]="'Cédula*'"
          [id]="'codigoUsuario'" formControlName="codigoUsuario" [control]="formulario.get('codigoUsuario')">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Nombre Usuario'" [label]="'Nombre Usuario*'"
           [id]="'nombreUsuario'" formControlName="nombreUsuario" [control]="formulario.get('nombreUsuario')">
        </app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'dscaCanalVenta'" [idOpcion]="'idCanalVenta'" [comboBox]="cmbDirecciones" formControlName="codigoDireccion"
          [control]="formulario.get('codigoDireccion')"[label]="'Cod. Dirección*'"[id]="'codigoDireccion'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
    [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>
</ng-template>